import React from 'react';
import { ClockIcon, HelpCircleIcon, LayersIcon, RouteIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { problems } from '../data/content';
const ICONS = {
  layers: LayersIcon,
  question: HelpCircleIcon,
  route: RouteIcon,
  clock: ClockIcon
};
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-brand-steel" data-id="element-133" data-mp="2vppl32fc7wa4">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-134" data-mp="39hcrhv2zul6m">
        <p className="text-[0.65rem] font-extrabold uppercase tracking-[0.16em] text-brand-blue" data-id="element-135" data-mp="39jqjtw6ahjah">
          ¿Te suena familiar?
        </p>
        <h2 id="problema" className="mt-1 font-display text-xl uppercase leading-tight text-brand-carbon sm:text-3xl" data-id="element-136" data-mp="3jf0oysrzi6sh">
          Quieres aprender automatización industrial y PLC, pero no sabes por
          dónde empezar.
        </h2>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-snug text-brand-muted" data-id="element-137" data-mp="1k2xygyky0c5b">
          Si estás comenzando desde cero o quieres agregar esta habilidad a lo
          que ya haces, probablemente conozcas alguna de estas situaciones:
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-138" data-mp="ocpy2podndwj">
          {problems.map((problem, i) => {
          const Icon = ICONS[problem.icon];
          return <Reveal key={problem.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-lg border-l-4 border-brand-blue bg-white p-3 text-left" data-id="element-139" data-mp="x4rvsg72ag34" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-brand-navy" data-id="element-140" data-mp="174slcjvixsfr">
                  <Icon size={15} className="text-brand-yellow" data-id="element-141" data-mp="1bzy79ioxf73u" />
                </span>
                <div data-id="element-142" data-mp="1g19w3lzz7oaz">
                  <h3 className="text-[0.8rem] font-extrabold uppercase leading-tight text-brand-carbon" data-id="element-143" data-mp="3dtfa89243js9">
                    {problem.title}
                  </h3>
                  <p className="mt-1 text-[0.78rem] leading-snug text-brand-muted" data-id="element-144" data-mp="3hv0u4ed2cyby">
                    {problem.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}